import React from 'react';
import { MaskedInput, MaskedInputProps } from '../MaskedInput';


export type DateOfBirthInputProps = Omit<MaskedInputProps, 'type'>;


export const DateOfBirthInput: React.VFC<DateOfBirthInputProps> = props => {
  return (
    <MaskedInput
      {...props}
      type="dob"
      mixHelperTextAndError
    />
  );
};
